import {
  ECategory,
  EConcurrencyType,
  EGeoType,
  IGetTopBetsByAnnouncementRequest,
} from '../../../../../repositories/auction/v2/get-top-bets-by-announcement';
import { IOfferState } from '../../../../reducers';
import { SERVICE_MAP, TOP_BETS_COUNT } from '../constants';

interface IGetTopBetsRequestParams {
  serviceId: string;
  offer: IOfferState;
}

export function getTopBetsRequestParams(params: IGetTopBetsRequestParams): IGetTopBetsByAnnouncementRequest {
  const {
    serviceId,
    offer: { category, id, bargainTerms, geo },
  } = params;

  const service = SERVICE_MAP[serviceId];
  const geoId = geo?.geoId || undefined;
  const geoType = (geo?.geoType as EGeoType) || undefined;

  return {
    topCount: TOP_BETS_COUNT,
    announcementId: id,
    category: category as ECategory,
    geoId,
    geoType,
    concurrencyType: EConcurrencyType.Local,
    price: bargainTerms.price,
    service,
  };
}
